import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, theme as antdTheme, App as AntApp } from 'antd';
import koKR from 'antd/locale/ko_KR';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import App from './App';
import './styles.css';

dayjs.locale('ko');

// 디자인 토큰 — 본문 CSS 시스템(브랜드 그린)과 일치
const theme = {
  algorithm: antdTheme.defaultAlgorithm,
  token: {
    colorPrimary:     '#1f7c46',
    colorSuccess:     '#1f7c46',
    colorWarning:     '#b07b00',
    colorError:       '#c83a3a',
    colorInfo:        '#2563eb',
    colorTextBase:    '#14211c',
    colorBgBase:      '#ffffff',
    colorBgLayout:    '#f4f8f6',
    colorBorder:      '#e6ece9',
    colorBorderSecondary: '#eff3f1',
    borderRadius:     8,
    borderRadiusLG:   12,
    borderRadiusSM:   6,
    fontFamily: `'Pretendard Variable', Pretendard, -apple-system, "Segoe UI", "Apple SD Gothic Neo", "Malgun Gothic", sans-serif`,
    fontSize: 14,
    fontSizeHeading1: 28,
    fontSizeHeading2: 22,
    fontSizeHeading3: 18,
    fontSizeHeading4: 16,
    controlHeight: 36,
    wireframe: false,
    boxShadow:    '0 1px 2px rgba(20, 30, 25, .04)',
    boxShadowSecondary: '0 4px 16px -6px rgba(20, 30, 25, .08)',
  },
  components: {
    Layout: {
      siderBg:      '#ffffff',
      headerBg:     '#ffffff',
      bodyBg:       '#f4f8f6',
      triggerBg:    '#f7f8f7',
      triggerColor: '#525854',
    },
    Menu: {
      itemBg:           'transparent',
      itemColor:        '#525854',
      itemHoverBg:      '#f7f8f7',
      itemHoverColor:   '#14211c',
      itemSelectedBg:   '#ecfaf1',
      itemSelectedColor:'#117a3c',
      itemActiveBg:     '#ecfaf1',
      itemHeight:       38,
      itemMarginInline: 8,
      itemBorderRadius: 6,
      iconSize: 16,
      collapsedIconSize: 16,
      groupTitleColor: '#9ba39e',
      groupTitleFontSize: 10.5,
    },
    Card: {
      headerFontSize: 14,
      headerFontSizeSM: 13,
      paddingLG: 24,
    },
    Statistic: {
      titleFontSize: 12,
      contentFontSize: 24,
    },
    Table: {
      headerBg:      '#fafbfa',
      headerColor:   '#525854',
      headerSplitColor: '#e6ece9',
      borderColor:   '#eff3f1',
      rowHoverBg:    '#f7f8f7',
      cellPaddingBlock: 10,
      cellPaddingInline: 14,
      cellFontSize: 13,
    },
    Button: {
      controlHeight: 36,
      borderRadius:  8,
      fontWeight: 600,
    },
    Input: {
      controlHeight: 36,
    },
    Select: {
      controlHeight: 36,
    },
    Modal: {
      borderRadiusLG: 14,
      titleFontSize: 16,
    },
    Tag: {
      borderRadiusSM: 6,
    },
  },
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider locale={koKR} theme={theme}>
      <AntApp>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AntApp>
    </ConfigProvider>
  </React.StrictMode>
);
